<template>
  <div class="edit-form-list-item">
    <div class="history-item">
      <div class="history-item-button">
        <div class="button">
          <el-button :disabled="!(index > 0 && length > 1)"
             icon="el-icon-arrow-up"
             circle
             @click.stop="handleCommand('moveUp')"></el-button>
        </div>
        <div class="button">
          <el-button :disabled="!(index + 1 != length && length > 1)"
             icon="el-icon-arrow-down"
             circle
             @click.stop="handleCommand('moveDown')"></el-button>
        </div>
      </div>
      <div class="history-item-content">
        <el-form class="history-form"
                 ref="historyItemForm"
                 :model="item"
                 :rules="rules"
                 @submit.native.prevent>
          <!-- <div class="history-form-date"> -->
          <div>
            <el-form-item prop="skillname">
              <div><label for="skillname" class="item-name">스킬 및 자격 입력</label></div>
              <el-input class="input-lg"
                        type="textarea"
                        id="skillname"
                        :autosize="{minRows: 1, maxRows: 4}"
                        :placeholder="descriptionPlaceholder"
                        v-model="item.skillname"
                        ref="desc"></el-input>
            </el-form-item>
            <el-form-item prop="years">
              <div><label for="years" class="item-name">경력</label></div>
              <el-input class="input-xxs"
                        placeholder="3"
                        title="年"
                        id="years"
                        v-model="item.years"
                        type="number"
                        :min="0"
                        :max="computedMaxYear"
                        ref="year">
              </el-input>
              <span>年</span>
            </el-form-item>
            <!-- </div> -->
          </div>
          <el-form-item prop="description">
            <div><label for="description" class="item-name">숙련도·설명</label></div>
            <el-input class="input-lg"
                      type="textarea"
                      id="desctipsion"
                      :autosize="{minRows: 1, maxRows: 4}"
                      :placeholder="descriptionPlaceholder2"
                      v-model="item.description"
                      ref="desc"></el-input>
          </el-form-item>
          <div class="errors"
               v-if="errors">
            <ul>
              <li v-for="(error, index) in errors"
                  :key="index">{{ error }}</li>
            </ul>
          </div>
          <div class="enter text-right">
            <el-button icon="el-icon-delete"
                       @click.stop="handleCommand('delete')">삭제</el-button>
            <el-button icon="el-icon-check"
                       @click.stop="$eventHub.$emit('deactivate-history-item')">OK</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    length: {
      type: Number
    },
    descriptionPlaceholder: {
      type: String
    },
    descriptionPlaceholder2: {
      type: String
    },
    descriptionMaxLength: {
      type: Number
    },
    minYear: {
      type: [Number, String]
    },
    maxYear: {
      type: [Number, String]
    }
  },
  data: function () {
    const app = this
    const validateYear = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > 6) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    const validateMonth = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > 4) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    const validateDescription = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > app.descriptionMaxLength) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    return {
      errors: [],
      rules: {
        year: [
          {
            validator: validateYear,
            message: '년도의 글자수가 길어요.',
            trigger: ['change', 'blur']
          }
        ],
        month: [
          {
            validator: validateMonth,
            message: '월의 글자수가 길어요',
            trigger: ['change', 'blur']
          }
        ],
        description: [
          {
            validator: validateDescription,
            message: '한 줄에 들어가는 글자 수를 초과하고 있습니다.문장을 줄이거나 행의 + 버튼을 클릭하여 추가 입력 해주세요.',
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },
  computed: {
    computedMinYear: function () {
      if (this.minYear) {
        return Number(this.minYear)
      }
      return 1900
    },
    computedMaxYear: function () {
      if (this.maxYear) {
        return Number(this.maxYear)
      }
      return new Date().getFullYear() + 3
    }
  },
  methods: {
    handleCommand: function (command) {
      if (command === 'addAbove') {
        this.$emit('add-history-item', this.index)
      } else if (command === 'addBelow') {
        this.$emit('add-history-item', this.index + 1)
      } else if (command === 'delete') {
        this.$emit('delete-history-item', this.index)
      } else if (command === 'duplicate') {
        this.$emit('add-history-item', this.index, this.item)
      } else if (command === 'moveUp') {
        this.$emit('move-history-item', {
          index: this.index,
          to: 'up'
        })
      } else if (command === 'moveDown') {
        this.$emit('move-history-item', {
          index: this.index,
          to: 'down'
        })
      }
    },
    resizeDesc: function () {
      const app = this
      this.$nextTick(function () {
        if (typeof app.$refs['desc'].resizeTextarea === 'function') {
          if (app.$refs['desc'].$el.offsetHeight) {
            app.$refs['desc'].resizeTextarea()
          }
        }
      })
    }
  },
  beforeMount: function () {
    this.$nextTick(function () {
      // 初回読み込み時にバリデーションを動かす
      this.$refs['historyItemForm'].validate().then().catch(function (e) {
        // console.error(e)
      })
    })
  },
  mounted: function () {
    this.$eventHub.$on('card-changed', this.resizeDesc)
  },
  destroyed: function () {
    this.$eventHub.$off('card-changed', this.resizeDesc)
  }
}
</script>
<style scoped lang="scss">
$white: #fff;
$basecolor: #f8f8f8;
$light-gray: #dcdfe6;
$errorcolor: #f56c6c;
/* .projects { */
/* background-color:rgba(246,247,249,0.8); */
/* } */
.project__invisible {
  display: none;
}
.project__invisible2 {
  display: none;
}
.edit-form-list-item {
  &.active {
    .project-item {
      border-top: dashed 1px $light-gray;
      padding: 1rem 0;
    }
  }
}
.history-item {
  display: flex;
  flex-direction: row-reverse;
}
.history-item-content {
  flex: 1;
  margin: .5rem 0;
  padding: .5rem 1rem;
  .attention-limit {
    font-size: .75rem;
    color: $errorcolor;
    &.character {
      padding: .5rem 0;
    }
    &.column {
      background: $white;
      margin: .5rem 0;
      padding: .5rem 1rem;
    }
  }
}
/* 詳細を隠す時に上下ボタンが高さを確保してしまうので修正 */
/* buttonにdisplay: flex; 追加 */
.history-item-button {
  .button {
    display: flex;
    button {
      &.is-disabled {
      }
    }
  }
}
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}
.list-enter-to {
}
.list-enter-active,
.list-leave-active {
}
.list-enter, .list-leave {
  /* opacity: 0; */
  /* transform: translateX(50px) scaleY(0.5); */
}
</style>
